import { getImagePreloadCandidates } from "../components/imageMeta";
import type { FunnelId } from "../funnel/types";

export const CHECKOUT_HERO_IMAGE_URL = "/alcove.webp";
export const CHECKOUT_HERO_IMAGE_URL_FAMILY = "/family-checkout-hero.webp";

export const getCheckoutHeroImageUrl = (funnelId: FunnelId): string =>
  funnelId === "family-devotional" ? CHECKOUT_HERO_IMAGE_URL_FAMILY : CHECKOUT_HERO_IMAGE_URL;

export const CHECKOUT_FEATURE_IMAGE_URLS = {
  dailyDrops: "/features_daily.webp",
  curiosityHabit: "/features_habit.webp",
  personalized: "/features_journey.webp",
  rewarding: "/features_peaceful.webp"
} as const;

// The paywall art is a video now, so only its poster needs preloading; the
// former collage stills are no longer on this screen.
const CHECKOUT_IMAGE_URLS = ["/offer-path.webp", "/paywall-grid-poster.webp"];

export const getCheckoutImagePreloadUrls = (): string[] => {
  const uniqueUrls = new Set<string>();

  for (const imageUrl of CHECKOUT_IMAGE_URLS) {
    const candidates = getImagePreloadCandidates(imageUrl);
    for (const candidate of candidates) {
      uniqueUrls.add(candidate);
    }
  }

  return Array.from(uniqueUrls);
};
